<!-- <div [ngClass]="className"> -->
<div [ngClass]="isCustomUiChange ? 'loader-container' : 'spinner-center'" *ngIf="searching">
  <mat-spinner [diameter]="80" color="primary"></mat-spinner>
</div>
<div [ngClass]="isCustomUiChange ? 'module-container' : ''" [hidden]="searching">
  <mat-card [ngClass]="isCustomUiChange ? 'module-card-card' : 'user-card module-card'">
    <mat-card-header *ngIf="!isCustomUiChange">
      <mat-card-title style="font-size: 16px">
        <span matBadge="{{ modules.length }}" matBadgeOverlap="false">Modules</span>
      </mat-card-title>
      <div style="width: 100% !important;">
        <button mat-button (click)="addNewModule()" matTooltip="Add Module"
          style="background: transparent;float:right !important; height: 100% !important">
          <mat-icon matTooltip="Add Module" aria-hidden="false" color="primary" style="text-align: center;
                width: 98%;float:right;">
            add
          </mat-icon>
        </button>
      </div>
      <!--  <mat-card-subtitle>
            Double Click row to edit.
          </mat-card-subtitle> -->
    </mat-card-header>

    <!-- new CSS chages apply for FEMD and DOM1 -->
    <mat-card-header *ngIf="isCustomUiChange" class="module-header">
      <mat-card-title class="module-title">
        <span matBadge="{{ modules.length }}" matBadgeOverlap="false">Modules</span>
      </mat-card-title>

      <!-- Search Bar -->
      <mat-form-field appearance="outline" class="module-search-field">
        <mat-label>Search</mat-label>
        <input matInput [(ngModel)]="searchValue" (keyup)="applyFilter($event.target.value)"
          placeholder="Search Module..." autocomplete="off" />
        <button mat-icon-button matSuffix *ngIf="searchValue" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <button mat-icon-button class="add-office-btn" (click)="addNewModule()">
        <mat-icon matTooltip="Add Office" color="primary">add</mat-icon>
      </button>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content [ngClass]="isCustomUiChange ? 'module-table-section' : 'module-card-content'">
      <br>
      <table mat-table [dataSource]="dataSource" matSort [ngClass]="isCustomUiChange ? 'module-table' : 'table-card-module'" class="mat-elevation-z8">
        <ng-container matColumnDef="ModuleId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'table-header-row'">Module ID</th>
          <td mat-cell *matCellDef="let module" matTooltip="{{module.ModuleId}}"> {{ module.ModuleId }} </td>
        </ng-container>

        <ng-container matColumnDef="ModuleName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'table-header-row'">Name</th>
          <td mat-cell *matCellDef="let module" matTooltip="{{module.ModuleName}}"> {{module.ModuleName}} </td>
        </ng-container>

        <ng-container matColumnDef="ModuleItemName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'table-header-row1'">Module Item</th>
          <td mat-cell *matCellDef="let module" matTooltip="{{module.ModuleItemName}}"> {{module.ModuleItemName}} </td>
        </ng-container>

        <ng-container matColumnDef="Roles">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'table-header-row2'">Roles</th>
          <td mat-cell *matCellDef="let module" matTooltip="{{module.RoleString}}"> {{module.RoleString}} </td>
        </ng-container>

        <ng-container matColumnDef="IsActive">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
          <td mat-cell *matCellDef="let module">
            <mat-icon matTooltip="Is Active" *ngIf="module.IsActive" color="primary">check_box</mat-icon>
            <mat-icon matTooltip="Cancel" *ngIf="!module.IsActive" style="color: red !important">cancel</mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="CreatedDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'table-header-row1'">Created Date</th>
          <td mat-cell *matCellDef="let module"> {{module.CreatedDate | date:'shortDate' }} </td>
        </ng-container>

        <ng-container matColumnDef="ModifiedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Modified By</th>
          <td mat-cell *matCellDef="let module" matTooltip="{{module.ModifiedBy}}"> {{module.ModifiedBy }} </td>
        </ng-container>



        <ng-container matColumnDef="edit" stickyEnd>
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'table-header-row3'"></th>
          <td mat-cell *matCellDef="let module">
            <button mat-button (click)="handleClick(module)" matTooltip="Create">
              <mat-icon matTooltip="Edit" color="primary">create</mat-icon>
            </button>

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5,10,20]" showFirstLastButtons></mat-paginator>
    </mat-card-content>
    <!--  <mat-card-actions>
          <button mat-raised-button color="primary" routerLink="/search">DONE</button>
        </mat-card-actions> -->
  </mat-card>
</div>